import { DataLayerAnalytics } from '../models/analytics.interface';

export const DataLayerAnalyticsMocks: DataLayerAnalytics = {
  event_detail: '',
  event: '',
  user: {
    attributes: {
      is_logged_in: '',
      login_method: '',
      login_state: ''
    },
    profile: {
      skymiles_number: '',
      skymiles_tier: '',
      email: '',
      encrypted_email: '',
      email_domain: '',
      available_miles: '',
      amex_card_type: '',
      company_name: ''
    }
  },
  page: {
    info: {
      legacy_page_name: 'My Profile Personal Details',
      page_name: 'dal:my profile:personal details',
      page_url: '/my-profile/personal-details',
      page_type: 'my-profile',
      previous_page_name: '',
      previous_page_url: '',
      section: 'my-profile',
      sub_section: 'personal-details',
      country: 'us',
      language: 'en',
      sys_env: 'desktop',
      page_load_time: 5
    }
  }
};
